import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

function InfoIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <g fill="none" fillRule="evenodd" transform="translate(-2 -1.5)">
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M8 13.5a6 6 0 0 1-6-6 6 6 0 0 1 6-6 6 6 0 0 1 6 6 6 6 0 0 1-6 6zm-.1-4.7c.3 0 .5-.2.5-.5
        0-.4.2-.6.6-.9.6-.4 1-.7 1-1.5 0-1-.9-1.5-2-1.5-1 0-1.7.5-1.8 1v.3c0 .3.1.5.3.5.2 0
        .4-.1.5-.3v-.1a1 1 0 0 1 1-.6c.6 0 1 .3 1 .8 0 .4-.3.6-.8 1-.5.3-.8.6-.8 1.2 0 .4.2.6.5.6zm0
        1.8c.3 0 .6-.3.6-.7 0-.3-.3-.6-.6-.6-.4 0-.7.3-.7.6 0 .4.3.7.7.7z"
        />
      </g>
    </SvgIcon>
  );
}

export { InfoIcon };
